// mixin.js
export default {
    methods:{
        shareThis(args){

            if (window.cordova) {
                let realUrl = this.$store.state.shared.real_url + args.url.split("#")[1];
                window.plugins.socialsharing.share(args.title+ " " + realUrl);
            }else{
                this.$store.commit("shared/setShareLinks",args);
            }
        }
    }
};
